import axios from 'axios';

// Get your Render URL
const RENDER_BACKEND_URL = 'https://ctf-backend-y4k6.onrender.com/api'; // <--- PASTE YOUR REAL URL HERE

// This will hold our token in memory
let jwtToken = null;

const api = axios.create({
    baseURL: RENDER_BACKEND_URL,
    // --- REMOVED withCredentials: true ---
});

// --- NEW: Axios Request Interceptor ---
// This function will run *before* every request
api.interceptors.request.use(
    config => {
        if (jwtToken) {
            // If we have a token, add it to the Authorization header
            config.headers['Authorization'] = `Bearer ${jwtToken}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// --- NEW: Function to update the token ---
export const setApiToken = (token) => {
    jwtToken = token;
};

export const fetchInitialState = () => {
    return api.get('/init');
};

export const postCommand = (command) => {
    return api.post('/command', { command });
};